<div
  class="c-theme-switcher"
  (click)="toggleTheme()"
  appDisableLightTheme
  [enableLightTheme]="enableLightTheme"
>
  <app-svg-icon
    class="c-theme-switcher__icon"
    [ngClass]="{ isActive: (isLightTheme$ | async) }"
    [icon]="'assets/images/theme-switcher/moon.svg'"
    [blank]="true"
  />

  <app-svg-icon
    class="c-theme-switcher__icon"
    [ngClass]="{ isActive: !!!(isLightTheme$ | async) }"
    [icon]="'assets/images/theme-switcher/sun.svg'"
    [blank]="true"
  />
</div>
